import { Component, ElementRef, Input } from '@angular/core';
import 'moment/locale/id';
import { RequestFakturRestService } from '../request-faktur-rest.service';
import Swal from 'sweetalert2';
import { APP_CONST } from '../../../app.const';
import { RequestFakturListComponent } from '../list/request-faktur-list.component';

@Component({
  selector: 'app-shipping-modal',
  templateUrl: 'shipping-modal.component.html',
  styleUrls: ['../request-faktur-module.scss']
})
export class ShippingModalComponent {
  @Input() requestFaktur: any;
  @Input() disabled: boolean;
  isModalOpen: boolean = false;
  uploadEndpoint = APP_CONST.API_FILE;
  photoPreviewModal: boolean = false;
  photoPreviewTitle: string = '';
  photoUrl: string = '';

  formShipping = {
    noResi: '',
    noFaktur: '',
    fotoBuktiPengiriman: ''
  };

  constructor(
    private _RequestFakturRest: RequestFakturRestService,

    public _requestFakturListComponent: RequestFakturListComponent,

    private el: ElementRef
  ) {}

  resetFormData() {
    this.formShipping = {
      noResi: '',
      noFaktur: '',
      fotoBuktiPengiriman: ''
    };
  }

  openModal() {
    this.isModalOpen = true;
    this.resetFormData();
    this.getPresignedUrl();
    this.formShipping.noResi = this.requestFaktur.noResi;
    this.formShipping.noFaktur = this.requestFaktur.noFaktur;
  }

  closeModal() {
    this.isModalOpen = false;
    this.resetFormData();
  }

  enableShipping() {
    return (
      this._requestFakturListComponent.canAccess('requestFakturShipping.create') &&
      this.requestFaktur?.status === 'approved-by-finance'
    );
  }

  async getPresignedUrl() {
    const filePayload = { storageFileName: this.requestFaktur.fotoBuktiPengiriman };
    this._RequestFakturRest.getPresignedUrl(filePayload).subscribe({
      next: response => {
        // Update the original object properties directly
        this.photoUrl = response.url;
      },
      error: err => {
        console.error('Error getting presigned URL:', err);
      }
    });
  }

  onImageFinishUploaded(image: any, inputName: string) {
    if (image?.storageFileName) {
      (this.formShipping as any)[inputName] = image.storageFileName;
    } else {
      Swal.fire('Error', 'Terjadi kesalahan saat mengunggah file. Silakan coba lagi.', 'error');
    }
  }

  deleteCurrentPhoto() {
    this.photoUrl = '';
    this.requestFaktur.fotoBuktiPengiriman = '';
  }

  closePhotoPreviewModal() {
    this.photoPreviewModal = false;
  }

  async openPhotoPreview(file, title) {
    this.photoPreviewModal = true;
    this.photoPreviewTitle = title;

    setTimeout(() => {
      const photoPreview = this.el.nativeElement.querySelector('#js-photoPreview');
      if (photoPreview) {
        photoPreview.src = file;
        photoPreview.href = file;
      } else {
        console.error('photoPreview element not found');
      }
    }, 0); // Wait for the DOM update
  }

  // Method to handle the submit action
  onSubmit(form) {
    if (form.valid) {
      // Prepare the data to be submitted
      const dataToSubmit = this.formShipping;

      // Here you would call your service to submit the data
      this._RequestFakturRest.shipping(this.requestFaktur._id, dataToSubmit).subscribe({
        next: response => {
          Swal.fire('Success', 'Request faktur shipping update success!', 'success');
          this._requestFakturListComponent.callHookDirectly('init');
          this.closeModal(); // Close modal on success
        },
        error: err => {
          const errorMessage = err.response.data.message;

          Swal.fire('Error', `Failed to update request faktur shipping: ${errorMessage}`, 'error');
        }
      });
    } else {
      Swal.fire('Error', 'Please fill in all required fields.', 'error');
    }
  }
}
